import { HasFeatureEnabledResponseDto } from '@tiendanube/common';
import axios from 'App/axios';

export const SubscriptionsService = {
  hasFeatureEnabled: async (): Promise<HasFeatureEnabledResponseDto> => {
    const { data } = await axios.get<HasFeatureEnabledResponseDto>(
      `/v1/stores/subscriptions/hasFeatureEnabled`,
    );
    return data;
  },
};
